import React from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import { DropdownSurface } from '../../shared/dropdown-surface';

type SelectDropdownContentProps = {
    children: React.ReactNode;
};

const SelectDropdownContent = ({ children }: SelectDropdownContentProps) => {
    return (
        <SelectPrimitive.Portal>
            <SelectPrimitive.Content position="popper" className="flos-custom-select-outer">
                <DropdownSurface viewportWrapper={(viewport) => <SelectPrimitive.Viewport asChild>{viewport}</SelectPrimitive.Viewport>}>{children}</DropdownSurface>
            </SelectPrimitive.Content>
        </SelectPrimitive.Portal>
    );
};

export { SelectDropdownContent };
